'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcBoldClose,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  Typography,
} from '@musinsa/mds';
import type { FC, PropsWithChildren } from 'react';
import { usePreventBodyScroll } from '../common/hooks';

const NoticeItem: FC<PropsWithChildren> = ({ children }) => (
  <Typography variant="body13pxReg" asChild>
    <li className="py-1 px-4 text-base-gray-9">
      <span className="mr-1">•</span>
      <span>{children}</span>
    </li>
  </Typography>
);

const NOTICES = [
  '진행 예정 정보는 무신사 큐레이터를 대상으로 특별히 제공하는 정보로 본인 외 정보 활용이 철저히 금지되며 외부 유출 또한 금합니다.',
  '무신사 내부 사정에 따라 조기 종료 및 정보가 변경될 수 있습니다.',
] as const;

interface EventNoticeSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const EventNoticeSheet: FC<EventNoticeSheetProps> = ({ open, onOpenChange }) => {
  usePreventBodyScroll({ open });

  return (
    <Sheet direction="bottom" open={open} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => onOpenChange(false)}>
          <SheetMotion direction="bottom">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer className="px-4 py-[9px]">
                <BottomSheetTitleBox>유의사항</BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => onOpenChange(false)}>
                  <IcBoldClose />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <ul className="flex flex-col pb-[12px]! safe-area-bottom">
              {NOTICES.map((text) => (
                <NoticeItem key={text}>{text}</NoticeItem>
              ))}
            </ul>
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};
